import { useDisclosure } from "@mantine/hooks";
import { useLanguage } from "../../../../../../stores/LanguageStore";
import { useEffect, useState } from "react";
import { sendZapierHook } from "../../../../../../api/ZapierApi";
import { notifications } from "@mantine/notifications";
import {
  Button,
  Group,
  Loader,
  Modal,
  Stack,
  Text,
  Tooltip,
} from "@mantine/core";
import { IconCloudUpload } from "@tabler/icons-react";
import BackButton from "../../../../../../components/View/BackButton";
import {
  executeCron,
  findCron,
  getCrons,
} from "../../../../../../api/ConfigsApi";
import { useParams } from "react-router-dom";
import { useProfileStore } from "../../../../../../stores/UserStore";

const MakeSyncer = ({ current, closeMenu, inSheet }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, { open, close }] = useDisclosure();
  const { userId } = useParams();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [finding, setFinding] = useState(true);

  const [syncing, setSyncing] = useState(null);
  const handleSync = (id) => {
    setSyncing(id);

    findCron(id)
      .then((r) => {
        let cronData = r.data.cron_profile.arguments;
        executeCron({
          id: id,
          args: {
            type: "prm_synchronise_with_make",
            datafield_ids: cronData.datafield_ids,
            contacts_selection: {
              filter: { mode: "or", values: [] },
              contact_ids: [current?.id],
              excluded_contact_ids: [],
            },
            prm_user_id:
              parseInt(userId) || useProfileStore.getState().profile?.id,
            resend_synchronized_contacts: true,
            hook_url: cronData?.hook_url,
          },
        })
          .then(() => {
            notifications.show({
              message: lang.sync_zapier.send_success,
              color: "tertiary.8",
            });
            handleClose();
          })
          .finally(() => setSyncing(null));
      })
      .catch(() => setSyncing(null));
  };

  const handleClick = () => {
    if (items?.length === 1) {
      setLoading(true);
      return findCron(items[0].id)
        .then((r) => {
          let cronData = r.data.cron_profile.arguments;
          executeCron({
            id: items[0].id,
            args: {
              type: "prm_synchronise_with_make",
              datafield_ids: cronData.datafield_ids,
              contacts_selection: {
                filter: { mode: "or", values: [] },
                contact_ids: [current?.id],
                excluded_contact_ids: [],
              },
              prm_user_id:
                parseInt(userId) || useProfileStore.getState().profile?.id,
              resend_synchronized_contacts: true,
              hook_url: cronData?.hook_url,
            },
          })
            .then(() => {
              notifications.show({
                message: lang.sync_zapier.send_success,
                color: "tertiary.8",
              });
              handleClose();
            })
            .finally(() => setLoading(false));
        })
        .catch(() => setLoading(false));
    }
    return open();
  };

  const handleClose = () => {
    closeMenu?.();
    close();
  };

  useEffect(() => {
    if (finding) {
      getCrons()
        .then((response) => {
          setItems(
            response.data.crons_list
              .sort((a, b) => b.id - a.id)
              .filter((x) => x.type === "prm_synchronise_with_make")
          );
        })
        .finally(() => {
          setFinding(false);
        });
    }
  }, [finding]);

  return (
    <>
      {inSheet ? (
        <Tooltip label={lang.sync_zapier.sync_make}>
          <Button
            variant="light"
            color="primary"
            px={"sm"}
            onClick={handleClick}
            disabled={finding || items.length === 0}
            loading={loading}
          >
            <IconCloudUpload size={18} />
          </Button>
        </Tooltip>
      ) : (
        <Button
          onClick={handleClick}
          variant="subtle"
          disabled={finding || items.length === 0}
          loading={loading}
          leftSection={
            finding ? <Loader size={18} /> : <IconCloudUpload size={18} />
          }
          justify="start"
        >
          {lang.sync_zapier.sync_make}
        </Button>
      )}

      <Modal
        opened={opened}
        onClose={handleClose}
        title={lang.sync_zapier.sync_make}
        centered
        zIndex={1300}
        pos={"relative"}
      >
        <Stack gap={"md"}>
          {items.map((item, index) => {
            return (
              <Button
                variant="light"
                key={item?.id}
                onClick={() => handleSync(item.id)}
                loading={syncing === item.id}
                h={52}
              >
                <Stack gap={4}>
                  <Text fw={600}>{item.name}</Text>
                  {/* <Text size="sm">{item.url}</Text> */}
                </Stack>
              </Button>
            );
          })}
        </Stack>

        <Group justify="end" mt={"md"}>
          <BackButton onClick={handleClose} />
        </Group>
      </Modal>
    </>
  );
};

export default MakeSyncer;
